import PropTypes from "prop-types";
import { testIds } from "../../../common/testData";
import { triggerGAEvent } from "../../../common/Analytics";
import styles from "./Button.module.scss";

const Button = (props) => {
  const { variant, btnText, type, disabled, onClick, icon } = props;
  const disabledClass = disabled ? "disabled" : "";
  const className = props.className ? props.className : "";

  const handleClick = () => {
    const params = {
      link_text: btnText,
    };
    triggerGAEvent("click", params);
    onClick && onClick();
  };

  return (
    <button
      className={`${styles[variant]} ${styles[disabledClass]} ${className}`}
      data-testid={testIds['button-component']}
      type={type ? type : "button"}
      onClick={handleClick}
      disabled={disabled}
      style={{ ...(icon && { display: "flex", alignItems: "center" }) }}
    >
      {icon && <img className={styles.icon} src={icon} alt="" />} {btnText}
    </button>
  );
};

Button.propTypes = {
  variant: PropTypes.string,
  btnText: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default Button;
